import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export const LandingCta: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-cta-container">
      <h2 className="landing-cta-title">Ready to Transform Your School?</h2>
      <p className="landing-cta-subtitle">
        Join schools across Zimbabwe running fees, results, and parent communication on Rongeka
      </p>
      <Button
        type="primary"
        size="large"
        onClick={() => navigate('/get-started')}
        className="landing-cta-button"
      >
        <span>Get Started for Free</span>
        <span className="landing-cta-button-arrow">→</span>
      </Button>
      <p className="landing-cta-note">
        Built for ECD, Primary, and Secondary schools across Zimbabwe
      </p>
    </div>
  );
};
